<!--  -->
<template>
  <div class="digitization-container">
    <div class="stats-wrap">
      <strip-map class="animate__animated animate__fadeInTopLeft"></strip-map>
      <china-map></china-map>
    </div>
    <div class="device-box animate__animated animate__fadeInRight" id="device-box">
      <ul class="device-wrap" id="device">
        <li v-for="(item, index) in deviceList" :key="index" class="device-item">   
           <el-tooltip effect="dark" :content="item.title" placement="left">
                <el-image :src="item.url" :alt="item.title" class="device-img" :preview-src-list="imgsList"></el-image>
            </el-tooltip>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import chinaMap from "./china.vue";
import stripMap from "./strip.vue";
import data from "@/mock/numhis_device.json";
export default {
  data() {
    return {
      deviceList: data.concat(data.slice(0,6)),
      imgsList: [],
      timer: null,
      timer2: null,
    };
  },
  components: {
    chinaMap,
    stripMap
  },
  mounted() {
    this.imgsList = this.deviceList.map(item => item.url)
    this.timer2 =setTimeout(_ => {
      this.initCarouselScroll(1);
      this.handleHover();
    }, 2000);
  },
  beforeDestroy(){
    this.timer2 && clearTimeout(this.timer2)
  },
  methods: {
    handleHover() {
      const carouselElem = document.getElementById("device");

      carouselElem.addEventListener(
        "mouseover",
        () => {
          this.timer && cancelAnimationFrame(this.timer);
        },
        false
      );

      carouselElem.addEventListener(
        "mouseout",
        () => {
          this.initCarouselScroll(1);
        },
        false
      );
    },
    initCarouselScroll(speed) {
      const boxHeight = document.querySelector(".device-box").offsetHeight; //盒子宽度
      const carouselHeight = document.getElementById("device").offsetHeight; //ul高度
      const maxScroll =
        this.deviceList.length > 6
          ? document.querySelectorAll(".device-item")[
              this.deviceList.length - 6
            ].offsetTop
          : boxHeight; //临界值
      const boxElem = document.getElementById("device-box");
      // const maxScroll = carouselWidth - (itemWidth + 25) * 6;
      const setTop = () => {
        if (carouselHeight > boxHeight) {
          const top = boxElem.scrollTop;
          boxElem.scrollTop = top + speed;
          if (Math.abs(top) >= maxScroll) {
            boxElem.scrollTop = 0;
          }
          this.timer = requestAnimationFrame(setTop);
        } else {
          this.timer && cancelAnimationFrame(this.timer);
        }
      };

      setTop();
    }
  }
};
</script>
<style lang='scss' scoped>
.digitization-container {
  display: flex;
  justify-content: space-between;

  .stats-wrap {
    width: 700px;
  }

  .device-box {
    width: 300px;
    // max-height: 100vh;
    height: 1680px;
    overflow-y: scroll;
    padding: 10px 20px;
    box-sizing: border-box;
    background: #eee;
    position: relative;
    // background: url(../../assets/image/device_bg.png) repeat-y;
    // background-size: 100% auto;
    // .device-wrap {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    // }
    .device-item {
      overflow: hidden;
      margin-bottom: 10px;
      background: #fff;
    }

    .device-img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/digitization.vue